import React, { useState, useEffect } from 'react';
import NavLinks from '../Navbar/NavLinks';
import { HashLink } from 'react-router-hash-link';
// import Contact from './Contact';



const NavBar = () => {
    const [top, setTop] = useState(!window.scrollY);
    const [isDarkMode, setIsDarkMode] = useState(
        document.documentElement.classList.contains("dark")
    );

    const [isOpen, setisOpen] = React.useState(false);
    
    function handleClick() {
        setisOpen(!isOpen);
    }

    
    useEffect(() => {
      const scrollHandler = () => {
        window.pageYOffset > 10 ? setTop(false) : setTop(true)
      };
      const handleThemeChange = () => {
        setIsDarkMode(document.documentElement.classList.contains("dark"));
      };
      window.addEventListener('scroll', scrollHandler);
      const observer = new MutationObserver(handleThemeChange);
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ["class"],
      });

      return () => {
        window.removeEventListener('scroll', scrollHandler);
        observer.disconnect();
    };
},[]);

      
      
      
    return (
        <nav  className={`fixed top-0 w-full z-30 transition-all duration-300 ease-in-out mb-16 ${
            top
              ? "bg-white dark:bg-[#1a202c]" // White in light mode, black in dark mode
              : "bg-[#f7e3eb]  shadow-lg" // Pink background when scrolling
          }`}>
            <div className="flex flex-row py-2">
                <div className="flex flex-row md:px-10 ml-3 lg:mt-5 md:ml-5 lg:ml-6  font-semibold w-full lg:w-full">
                    <HashLink smooth to="/#hero"><h1 className="lg:font-bold lg:text-2xl sm:text-xl font-mono text-[#b54a73]">HILINA MULUGETA</h1></HashLink>
                    
                </div>
                <div className="group flex flex-col items-right lg:items-right md:ml-0 lg:ml-0 mr-3 lg:w-full">
                    <button className="p-2 rounded-lg lg:hidden text-[#b54a73] " onClick={handleClick}>
                        <svg className="h-6 w-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            {isOpen && (
                            <path fillRule="evenodd" clipRule="evenodd" d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z" />
                            )}
                            {!isOpen && (
                            <path fillRule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z" />
                            )}
                        </svg>
                    </button>
                    <div className='hidden md:space-x-2 lg:inline-block p-2 lg:items-left md:ml-0 xl:ml-0 lg:pl-0'>
                        <NavLinks />
                    </div>
                        <div className={`fixed top-14 right-0 w-[55%] p-10 z-30 transition-transform duration-300 ease-in-out space-y-5  text-center pl-4 pr-4 rounded-xl sm:p-2 bg-white dark:bg-[#1a202c] lg:hidden shadow-lg 
                          ${isOpen ? "visible opacity-100 scale-100" : "invisible opacity-0 scale-95"}`}
>
                        <div className='w-full flex flex-col ml-0 pl-3 '>
                            <NavLinks />
                        </div>                                                
                    </div>

                </div>
            </div>
        </nav>
    );
};
    



export default NavBar;
